import { ActionTree } from "vuex";
import { ServiceImplementationState, ServiceImplementation } from "./model";
import { RootStateType } from "@/store";
import { AxiosResponse } from "axios";

const actions: ActionTree<ServiceImplementationState, RootStateType> = {
  findList({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].get('/service_implementations', { params: params })
      .then((response: AxiosResponse) => {
        const serviceImplementations: ServiceImplementation[] = response.data;
        commit('setServiceImplementations', serviceImplementations)
        return serviceImplementations
      })
  },
  find({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].get(`/service_implementations/${id}`)
        .then((response: AxiosResponse) => {
          const serviceImplementation: ServiceImplementation = response.data;
          commit('setServiceImplementation', serviceImplementation);
          return serviceImplementation;
        });
  },
  create({ rootGetters, commit }, params) {
    return rootGetters['hcs/client'].post('/service_implementations', params)
    .then((response: AxiosResponse) => {
      const serviceImplementation: ServiceImplementation = response.data;
      commit('replaceServiceImplementation', serviceImplementation)
      return serviceImplementation
    })
  },
  update({ rootGetters, commit }, params) {
     return rootGetters['hcs/client'].patch(`/service_implementations/${params.id}`, params)
       .then((response: AxiosResponse) => {
         const serviceImplementation: ServiceImplementation = response.data;
         commit(('updateServiceImplementation'), serviceImplementation)
         return serviceImplementation
       })
   },
   delete({ rootGetters, commit }, id) {
     return rootGetters['hcs/client'].delete(`/service_implementations/${id}`)
       .then((response: AxiosResponse) => {
         commit(('deleteServiceImplementation'), id)
       })
   }
}

export default actions;
